import React from 'react';
import PropTypes from 'prop-types';
import { Element } from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';
import TabControl from './TabControl';
import { heroDataType } from './types';

const DesktopAndTablet = ({ data }) => {
  return (
    <Element className={styles.tabControlContainer}>
      <TabControl contentList={data?.summitHeroData?.heroContent?.[0].content} />
    </Element>
  );
};

DesktopAndTablet.propTypes = {
  data: PropTypes.shape({
    heroData: heroDataType
  })
};

DesktopAndTablet.defaultProps = {
  data: {}
};

export default React.memo(DesktopAndTablet);
